<template>
  <h2>Updates</h2>
  <div class="dialog-content text-gray">You dont have any notifications yet</div>
</template>

<script lang="ts" setup>

</script>